// defines the way edges are routed
export var EdgeRoutingMode;
(function (EdgeRoutingMode) {
    EdgeRoutingMode[EdgeRoutingMode["Spline"] = 0] = "Spline";
    EdgeRoutingMode[EdgeRoutingMode["SplineBundling"] = 1] = "SplineBundling";
    EdgeRoutingMode[EdgeRoutingMode["StraightLine"] = 2] = "StraightLine";
    EdgeRoutingMode[EdgeRoutingMode["SugiyamaSplines"] = 3] = "SugiyamaSplines";
    EdgeRoutingMode[EdgeRoutingMode["Rectilinear"] = 4] = "Rectilinear";
    EdgeRoutingMode[EdgeRoutingMode["RectilinearToCenter"] = 5] = "RectilinearToCenter";
    EdgeRoutingMode[EdgeRoutingMode["None"] = 6] = "None";
})(EdgeRoutingMode || (EdgeRoutingMode = {}));
//# sourceMappingURL=EdgeRoutingMode.js.map